module.exports = __webpack_public_path__ + "static/media/img37.cc3d8c46.jpg";